import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './views/theme/base/base.component';
import { AuthGuard, ModuleGuard } from './core/auth';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./views/pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () => import('./views/pages/error/error.module').then((m) => m.ErrorModule),
  },
  {
    path: 'callback',
    loadChildren: () =>
      import('./views/pages/callback/callback.module').then((m) => m.CallbackModule),
  },
  {
    path: 'callback-sso',
    loadChildren: () =>
      import('./views/pages/callback-sso/callback-sso.module').then((m) => m.CallbackSsoModule),
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'search',
        canActivate: [AuthGuard],
        // canActivate: [ModuleGuard],
        loadChildren: () =>
          import('./views/pages/general-search-dashboard/general-search-dashboard.module').then(
            (m) => m.GeneralSearchDashboardModule,
          ),
      },
      {
        path: 'calendar',
        canActivate: [ModuleGuard, AuthGuard],
        data: { permissionName: 'accessToCalendarModule' },
        loadChildren: () =>
          import('./views/pages/calendar/calendar.module').then((m) => m.CalendarModule),
      },
      {
        path: 'followup',
        loadChildren: () =>
          import('./views/pages/follow-up/follow-up.module').then((m) => m.FollowUpModule),
      },
      {
        path: 'task',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/pages/task/task.module').then((m) => m.TaskModule),
      },
      {
        path: 'notifications',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./notification/notification.module').then((m) => m.NotificationModule),
      },
      {
        path: 'management/docs',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/documents-management/documents-management.module').then(
            (m) => m.DocumentsManagementModule,
          ),
      },
      {
        path: 'management/activity-tracking',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./activity-tracking/activity-tracking.module').then(
            (m) => m.ActivityTrackingModule,
          ),
      },
      {
        path: 'enrollment-verification',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./phi-registration/phi-registration.module').then((m) => m.PhiRegistrationModule),
      },
      {
        path: 'management/statements-collections',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./statements-collections/statements-collections.module').then(
            (m) => m.StatementsCollectionsModule,
          ),
      },
      {
        path: 'management',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/management/management.module').then((m) => m.ManagementModule),
      },
      {
        path: 'lists',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/apps/lists/lists.module').then((m) => m.ListsModule),
      },
      {
        path: 'events',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/apps/events/events.module').then((m) => m.EventsModule),
      },
      {
        path: 'timeline',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/apps/timeline/timeline.module').then((m) => m.TimelineModule),
      },
      {
        path: 'user-management',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/user-management/user-management.module').then(
            (m) => m.UserManagementModule,
          ),
      },
      {
        path: 'agreement-management',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/agreement-management/agreement-management.module').then(
            (m) => m.AgreementManagementModule,
          ),
      },
      {
        path: 'activity-log',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/active-log/activity-log.module').then((m) => m.ActivityLogModule),
      },
      {
        path: 'login-log',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/login-log/login-log.module').then((m) => m.LoginLogModule),
      },
      {
        path: 'me',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/pages/me/me.module').then((m) => m.MeModule),
      },
      {
        path: 'sale',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/apps/sales/sales.module').then((m) => m.SalesModule),
      },
      {
        path: 'data-analysis',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/data-analysis/data-analysis.module').then(
            (m) => m.DataAnalysisModule,
          ),
      },
      {
        path: 'links',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/Link-view/link-view.module').then((m) => m.LinkViewModule),
      },
      {
        path: 'event-legacies',
        canActivate: [ModuleGuard],
        data: { permissionName: 'accessToEventLegacies' },
        loadChildren: () =>
          import('./views/pages/event-legacies/event-legacies.module').then(
            (m) => m.EventLegaciesModule,
          ),
      },
      {
        path: 'filtered-view',
        canActivate: [AuthGuard],
        // canActivate: [ModuleGuard],
        // data: {permissionName: 'accessToEventLegacies'},
        loadChildren: () =>
          import('./views/pages/filtered-view/filtered-view.module').then(
            (m) => m.FilteredViewModule,
          ),
      },
      {
        path: 'med-review',
        canActivate: [AuthGuard],
        // canActivate: [ModuleGuard],
        // data: {permissionName: 'accessToEventLegacies'},
        loadChildren: () =>
          import('./views/pages/med-review/med-review.module').then((m) => m.MedReviewModule),
      },
      {
        path: 'bridgepay',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./core/bridge-pay/bridgepay.module').then((m) => m.BridgePayModule),
      },
      {
        path: 'compliance',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/compliance/compliance.module').then((m) => m.ComplianceModule),
      },
      {
        path: 'concepts-manage',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/concepts-management/concepts-management.module').then(
            (m) => m.ConceptsManagementModule,
          ),
      },
      {
        path: 'forms-templates',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/forms-templates/forms-templates.module').then(
            (m) => m.FormsTemplatesModule,
          ),
      },
      {
        path: 'alerts-notifications-log',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./views/pages/sent-alerts-notifications/alerts-notifications-log.module').then(
            (m) => m.AlertsNotificationsLogModule,
          ),
      },
      {
        path: 'email-fax',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./email-and-fax/email-and-fax.module').then((m) => m.EmailAndFaxModule),
      },
      {
        path: 'forms-templates/ai-agent',
        canActivate: [AuthGuard, ModuleGuard],
        data: { permissionName: 'accessToFormAiAgent' },
        loadChildren: () =>
          import('./views/pages/ai-agent/ai-agent.module').then((m) => m.AiAgentModule),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: '**', redirectTo: 'error', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [ModuleGuard],
})
export class AppRoutingModule {}
